import { setContext } from '@apollo/client/link/context';
import { Constants } from './core/constants';

// Basic link setup for Apollo
// Authorization link setup for Apollo
export const contextAuth = setContext(() => {
  const token = localStorage.getItem(Constants.TOKEN);
  const baseHeaders = {
    Accept: 'application/json',
  };
  return {
    headers: token ? {
      ...baseHeaders,
      Authorization: `Bearer ${token}`,
    } : baseHeaders,
  };
});
